import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP } from '../../app.config';
import { Router } from '@angular/router';
import { UserService } from 'src/app/user.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private router: Router,
    private userService: UserService,
  ) {}

  @ViewChild('focusthis') focusInput;
  email;
  password;
  confirm;
  isLoading = false;
  secret;
  first = false;
  errortext = '';
  ngOnInit(): void {

    }


  ngAfterViewChecked(): void {
    if (!this.first) {
      this.focusInput.nativeElement.focus();
      this.first = true;
    }
  }


  register() {
    this.errortext = null;
    this.isLoading = true;
    
    // Option 1: Use Cidaas SDK for browser-based registration
    // This will redirect to the Cidaas registration page
    this.userService.registerWithBrowser()
      .catch(error => {
        console.error("Registration error:", error);
        this.errortext = 'There was an error with registration. Please try again.';
        this.isLoading = false;
        
        // Fallback to the existing API if SDK registration fails
        this.registerWithExistingAPI();
      });
  }
  
  // Fallback method using the existing API
  private registerWithExistingAPI() {
    this.userService
      .register(this.email, this.password)
      .then((data) => {
        this.userService
          .login(this.email, this.password)
          .then((data) => {
            //Login Success
          
            this.isLoading = false;

            const user = {
              username: this.email,
              //@ts-ignore
              token: data.access_token,
            };

            this.saveToLocalStorage(user);
            this.router.navigate(['/administration']);
          })
          .catch((error) => {
            //Login Fail
            this.errortext = 'There was an error logging you in. Please contact support.';
            this.isLoading = false;
          });
      })
      .catch((error) => {
        //Register Fail
        this.errortext = 'There was an error creating your account. ' + (error.error?.message || 'Please try again.');
        this.isLoading = false;
      });
  }

  saveToLocalStorage(user) {
    if (localStorage.getItem('user')) {
      let olduser = JSON.parse(localStorage.getItem('user'));

      olduser.username = user.username;
      olduser.token = user.token;

      localStorage.setItem('user', JSON.stringify(olduser));
    } else {
      localStorage.setItem('user', JSON.stringify(user));
    }
  }
}
